export default __webpack_public_path__ + "static/media/Path1669-tata-neu.bf9ed95f.png";